var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cascaderSearch",
      style: _vm.cssVar,
      on: {
        mouseenter: function($event) {
          _vm.isMouseIn = true
        },
        mouseleave: function($event) {
          _vm.isMouseIn = false
        }
      }
    },
    [
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: {
            placement: "bottom-start",
            "visible-arrow": false,
            "popper-class": "cascader_popover",
            trigger: "click"
          },
          on: {
            show: function($event) {
              _vm.isShowList = true
              _vm.relocation()
            },
            hide: function($event) {
              _vm.isShowList = false
            },
            "after-enter": _vm.afterShow
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowList,
                  expression: "isShowList"
                }
              ],
              staticClass: "default_area"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.taskList.length > 0,
                      expression: "taskList.length>0"
                    }
                  ],
                  staticClass: "haveData"
                },
                [
                  _vm.isCanSearch === "true"
                    ? _c(
                        "div",
                        { staticClass: "search" },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入内容",
                              "prefix-icon": "kdfont kdfont-f"
                            },
                            on: { change: _vm.searchTask },
                            model: {
                              value: _vm.searchText,
                              callback: function($$v) {
                                _vm.searchText = $$v
                              },
                              expression: "searchText"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "check_box" },
                    [
                      _vm.taskListShow.length > 0 && _vm.isShowPanel
                        ? _c("el-cascader-panel", {
                            key: _vm.refresh,
                            ref: "cascader",
                            attrs: {
                              options: _vm.taskListShow,
                              props: {
                                emitPath: true,
                                multiple: _vm.multiple === "true"
                              }
                            },
                            on: {
                              change: _vm.changePanel,
                              "expand-change": _vm.relocation
                            },
                            model: {
                              value: _vm.checkList,
                              callback: function($$v) {
                                _vm.checkList = $$v
                              },
                              expression: "checkList"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.taskListShow.length === 0,
                              expression: "taskListShow.length === 0"
                            }
                          ],
                          staticClass: "noData"
                        },
                        [_vm._v("搜索结果为空")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.multiple === "true"
                    ? _c("div", { staticClass: "selected" }, [
                        _vm._v("已选 "),
                        _c("span", [_vm._v(_vm._s(_vm.checkList.length))]),
                        _vm._v(" 项")
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.taskList.length === 0,
                      expression: "taskList.length === 0"
                    }
                  ],
                  staticClass: "noData"
                },
                [_vm._v("暂无可选数据")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "input_area",
              attrs: { slot: "reference" },
              slot: "reference"
            },
            [
              _vm.multiple === "true"
                ? _c(
                    "div",
                    { staticClass: "text_area_multiple" },
                    _vm._l(_vm.checkList, function(item, index) {
                      return _c("div", { staticClass: "text_item" }, [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item[item.length - 1]))
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "kdfont kdfont-guanbi8",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.deleteItem(item)
                            }
                          }
                        })
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.multiple === "false"
                ? _c("div", { staticClass: "text_area_single" }, [
                    _c("div", { staticClass: "text_item" }, [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.checkList[_vm.checkList.length - 1]))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "kdfont kdfont-guanbi8",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.clearSelected($event)
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "kdfont kdfont-xiala",
                class: { rotate: _vm.isShowList }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }